import * as angular from 'angular';

import { LicenseModel } from './license.factory';

export const licenseModel = angular.module('go.models.licenseModel', [])
	.factory('LicenseModel', LicenseModel)
	.name;
